/** Cloudflare preview/staging hosts — UI layout follows viewport, not kiosk hardware mode. */
export function isPreviewDeploymentHost(hostname = globalThis.location?.hostname ?? ''): boolean {
    return hostname.endsWith('.pages.dev') || hostname.endsWith('.workers.dev');
}
